export default __webpack_public_path__ + "static/media/CommingSoon.5bdb7328.png";